/**
 * «Esta pantalla va DENTRO de otra.»
 *
 * Cobros, Movimientos, Mantenimiento, Informes y la vista del inquilino eran cinco secciones
 * sueltas del menú que solo informan. Ahora viven como pestañas de una sola página,
 * «Seguimiento». Cada una sigue pintando su `PageHeader` como siempre; con este contexto a
 * `true`, el encabezado se repliega: sin título (el de la página contenedora ya dice dónde
 * estás) pero CON su descripción y sus botones de acción, que son funciones y no se pierden.
 *
 * Un contexto y no una prop en cada pantalla: así las cinco no cambian por dentro y siguen
 * funcionando solas —la del inquilino es, además, toda la aplicación de la inquilina.
 */
import { createContext, useContext } from 'react';

export const EmbeddedContext = createContext(false);

export function useEmbedded(): boolean {
  return useContext(EmbeddedContext);
}
